import { DegreeTypeText } from '../../../keyword-helper/enums/DegreeTypeText';
import { KeywordHelperType } from '../../../keyword-helper/enums/KeywordHelperType';
import { KeywordHelperContent } from '../../../keyword-helper/KeywordHelperContent';

class WrongPortalBachelorsDefinition extends KeywordHelperContent {
	public constructor() {
		super(
			KeywordHelperType.WRONG_PORTAL,
			DegreeTypeText.BACHELOR,
			'https://www.bachelorsportal.com',
			'Bachelorsportal.com'
		);
	}
}

export default new WrongPortalBachelorsDefinition();
